import { render } from "./CommunityInvolvementSection.vue?vue&type=template&id=9d33396e&scoped=true"
import script from "./CommunityInvolvementSection.vue?vue&type=script&lang=js"
export * from "./CommunityInvolvementSection.vue?vue&type=script&lang=js"

import "./CommunityInvolvementSection.vue?vue&type=style&index=0&id=9d33396e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d33396e"]])

export default __exports__